import React from 'react';
import { useFlowData, useLoadingStatus } from '../../Context/FlowDataProvider';
import { MainLineView } from '../MainLineView/MainLineView';
import { ProgressViewer } from '../ProgressViewer/ProgressViewer';
import { useStyles } from './FlowView.styles';
import { PaymentProvider } from '../../Service/Stripe/PaymentProvider';
import { AcuityProvider } from '../../Service/Acuity/AcuityProvider';
import { TypeformProvider } from '../../Service/Typeform/TypeformProvider';
import { BlueprintSchedulingProvider } from '../../Service/BlueprintScheduling/BlueprintSchedulingProvider';

export type FlowViewProps = {};

export const FlowView: React.FC<FlowViewProps> = () => {
  const styles = useStyles();
  const blueprintFlowData = useFlowData();
  const loadingStatus = useLoadingStatus();

  return (
    <div className={styles.flowViewContainer}>
      <div className={styles.flowViewContainerContent}>
        <PaymentProvider>
          <BlueprintSchedulingProvider>
            <AcuityProvider>
              <TypeformProvider>
                <MainLineView lodingStatus={loadingStatus} blueprintFlowData={blueprintFlowData} />
                <ProgressViewer
                  blueprintFlowData={blueprintFlowData}
                  loadingStatus={loadingStatus}
                />
              </TypeformProvider>
            </AcuityProvider>
          </BlueprintSchedulingProvider>
        </PaymentProvider>
      </div>
    </div>
  );
};
